<template>
    <div id="page-content">
        <!-- 数据列表 -->
        <div class="content-list">
            <ul>
                <li v-for="(item, index) in dataList" :key = index>
                    <span class="indexAPP" style="z-index: 1;">
                        <i>{{ index + 1 }}</i>
                    </span>
                    <div class="scene_img_box"
                        @click="clickImgBg(item, true, index)"
                        :style="{'background-image' : 'url(\'' + item.img + '\'),url(../../static/img/scene-default.png)' }"
                        v-if="item.img">
                        <span class="recommand" v-if="item.hasOwnProperty('author') || (item.plugin_type == 1)" ><span class="recommand_label"></span></span>
                        <div data-content="预览资源"
                            class="bottom_left tooltip-box top"
                            v-on:mouseenter="showTooltip"
                            v-on:mouseleave="cancelTooltip">
                            <i data-content="预览资源" class="fa fa-search tooltip-box top" style="font-size: 1.2em;">
                            </i>
                        </div>

                    </div>
                    <div class="scene_img_box"
                        @click="clickImgBg(item, true)"
                        :style="{'background-image' : 'url(\'' + 'https://3dmomoda-static.oss-cn-beijing.aliyuncs.com/chart/' + item._id + '.jpg' +'\'),url(../../static/img/scene-default.png)' }"
                        v-else>
                        <span class="recommand"  v-if="item.hasOwnProperty('author') || (item.plugin_type == 1)"><span class="recommand_label"></span></span>
                        <div data-content="预览资源"
                            class="bottom_left tooltip-box top"
                            v-on:mouseenter="showTooltip"
                            v-on:mouseleave="cancelTooltip">
                            <i data-content="预览资源" class="fa fa-search tooltip-box top" style="font-size: 1.2em;">
                            </i>
                        </div>
                    </div>
                    <div class="modelList_info">
                        <div class="author_info shop_author_info">
                            <a class="tooltip-box top">
                                <img class="author_headImg scene_author_headImg" src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACgAAAAoCAMAAAC7IEhfAAAAAXNSR0IArs4c6QAAAU1QTFRFAAAA/////6o5/5VA/5c6/5I6/484/Y84/Y82/Y83/Y43/Y42/I82/I83/Y82/Y42/Y83/Y43/Y83/Y82/I42/I43/I85/JA5/JE7/JE8/JE9/JI+/JM//JRB/JVE/JZE/JZF/JdG/JhI/JlJ/JlK/JpM/JtN/JxP/J1S/J5T/KBX/KFY/KFZ/KNc/KRe/Kdj/Kpp/Ktq/Kxs/K1t/K5v/LF0/LF1/bN5/bR7/bV8/biB/buH/byJ/b6L/cCP/cOU/cSW/cSX/cid/cie/cyk/c+p/dCr/dGu/dKv/dSy/da2/da3/de4/tm8/tq9/tu//tzB/t7E/t/G/t/H/uHK/uPN/uPO/ubS/ufV/ufW/ujX/urZ/uvc/uvd/uze/u/k/vDk/vTs/vXu/vbw/vfx/vjz/vn0/vn1/vr2/vv5/vz6/v38/v79/v7+////xH9XNgAAABR0Uk5TAAEJDBYjUnJ/goOlqr/T2ejy8/4s5yf1AAABnUlEQVQ4y5WVWVvTYBCFB5qSlK6kr6CIbKbILuICuFZacCsqlF1AEXABnP9/yUVDrdBlfK/yPDn55pnzzZyI/EPUjSfTvp9Oxt2oNMSJpaghFXPqyiKezxV8L3Jd15GhDpmOK7I2L0tdsl5bra49QUMS7TXnNdFB4u+ZHk3xqn1kmwuzYUeRDC3IRCyFq8Udv7XQd0SkEwMxEUlZhCmRKCai4jZ8N/C8B8g9BMCVeD1Nrg9gfoQbTOUAiEsSgJX7AIUp3izBwqH+KY/A4Mq5Hj2tfJqUNAD6CRjX2WEt8Ui/5d+e7d9kQz8WvuoTANJScVE/AxM6G2iJzZ93Ia9zt7UI/d+3K05KFwC/y8C0zgRa4mQDmNTFAX0ArP4AoCssvXPcD691PNASp2VgTIt9WoA7h7th6Uozc3rwcvlsrzvQD5yuAaNaZOv83at9XQibCe15dqK6fo+hgxm+PAZ4nycoq/56QWhP1fBb3df97Om9fHLtV2geColZx8w8uOZVsC+XeV3tAWCPFHNI2WPPHqT/Ec0i4nSawr7F7+MCX2CBaiy/Id0AAAAASUVORK5CYII="/>
                            </a>
                            <span class="author_name no-effect">{{ item.name }}</span>
                        </div>
                    </div>
                </li>
            </ul>
        </div>
        <thingjs-x-pop-up v-if="popupshow" :propContent = propContent @cancel="cancelClick($event)"></thingjs-x-pop-up>
        <preview-decor v-if="decorshow" :decorData = decorData  @cancel="closeDecor($event)"></preview-decor>
        <!-- lodding -->
        <div class="modelList_footer">
            <h4 class="text_muted" v-if="!isLoadComplete">加载中...</h4>
            <div class="load_more_btn" v-if="!isLastPage&&isLoadComplete&&dataList.length >= param.pageSize">加载更多<i class="fa fa-arrow-circle-o-down"></i></div>
            <h4 v-if="isLastPage" class="text_muted">已显示全部</h4>
        </div>
    </div>
</template>

<script>
import bus from '../assets/js/eventBus';
import { postLowCodePlugins,postThingxPlugins } from '../network/thingxApi'
import thingjsXPopUp from '../components/thingjs-x/thingjsXPopUp.vue'
import previewDecor from './previewDecor.vue'

export default {
    data() {
        return {
            // 返回数据
            dataList: [],
            // lodding
            isLoadComplete: false,
            // 数据全部加载
            isLastPage: false,

            // 弹窗
            propContent: {
                clickImgBgUrl:'',
                title:'',
                code: 'lowCode'
            },
            popupshow: false,
            decorshow: false,
            decorData:{},

            param: {
                pageNumber: 1, // 页码
                pageSize: 24, // 条数
                typeName: '', // 分类（大）
                type: '', // 资源类型（小）
                resourceName: '', // 低代码插件类别监听
            },

            interfaces: [
                // 效果模板
                {smallId:"interfaceAll",smallType:'',typeName:'效果模板'},
                {smallId:"parkTemplate",smallType:'园区模板',typeName:'效果模板'},
                {smallId:"mapTemplate",smallType:'地图模板',typeName:'效果模板'},
                // 标记
                {smallId:"accessoriesAll",smallType:'',typeName:'标记'},
                {smallId:"markingPoints",smallType:'点',typeName:'标记'},
                {smallId:"connect",smallType:'线',typeName:'标记'},
                {smallId:"noodles",smallType:'面',typeName:'标记'},
                {smallId:"dataTemplate",smallType:'数据面板',typeName:'标记'},
                // {smallId:"particle",smallType:'粒子',typeName:'标记'},
                // {smallId:"entity",smallType:'实体',typeName:'标记'},
                // {smallId:"combination",smallType:'组合',typeName:'标记'},
                // 图表
                {smallId:"resolvingPowerAll",smallType:'',typeName:'图表'},
                {smallId:"resolvingPower1920",smallType:'1920*1080',typeName:'图表'},
                {smallId:"resolvingPowerQita",smallType:'其他分辨率',typeName:'图表'}
            ]
        }
    },
    components: {
        thingjsXPopUp,
        previewDecor
    },

    created () {
        this.init()
    },
    mounted () {
        bus.$on("lowcodePluginSearch", (data) => {
            let { keyWord, type, smallType = '' } = data;
            switch(type){
                case 'interfaceTemplate':
                    this.param.typeName = "效果模板";
                    this.param.type = '';
                    break;
                case 'accessoriesPlugin':
                    this.param.typeName = "标记";
                    this.param.type = '';
                    break;
                case 'chartPlugin':
                    this.param.typeName = "图表";
                    this.param.type = '';
                    break;
                case 'layerPlugin':
                    this.param.typeName = "图层业务";
                    this.param.type = '4';
                    break;
                case 'businessPlugin':
                    this.param.typeName = "业务模板";
                    this.param.type = '5';
                    break;
                case 'twinsPanel':
                    this.param.typeName = "孪生体面板";
                    this.param.type = '6';
                    break;
                case 'sceneControlPlugin':
                    this.param.typeName = "场景控制插件";
                    this.param.type = '7';
                    break;
                case 'skinPlugin':
                    this.param.typeName = "皮肤插件";
                    this.param.type = '8';
                    break;
                case 'corePlugin':
                    this.param.typeName = "核心插件";
                    this.param.type = '9';
                    break;
                case 'extendPlugin':
                    this.param.typeName = "扩展插件";
                    this.param.type = '10';
                    break;
                case 'operatingAtom':
                    this.param.typeName = "操作原子";
                    this.param.type = '11';
                    break;
                case 'plugins':
                this.param.typeName = "";
                    this.param.type = '';
            }
            let resultSmallType = this.interfaces.find((value) => {
                if(value.smallId == smallType && smallType){
                    return value;
                }
                return '';
            })
            if(this.param.type == '4' ||this.param.type == '5' || this.param.type == '6'|| this.param.type == '7'|| this.param.type == '8'|| this.param.type == '9'|| this.param.type == '10'|| this.param.type == '11') {
                this.param.type =this.param.type;
            }else {
                this.param.type = resultSmallType ? resultSmallType.smallType : '';
            }
            this.param.resourceName = keyWord;

            this.init(true)
        });
        //监听滚动事件，滚动到底部就去加载新的东西
        this.onscrollData()

        // 留资拦截
        bus.$on("thingx-plugin",(data) => {
            if(data.typeName == "标记"){
                this.decorshow = true;
                this.decorData = data;
            } else {
                this.clickImgBg(data,false);
            }
        })
    },

    // 销毁bus
    beforeDestroy () {
        bus.$off("thingx-plugin");
    },

    methods: {
        init(pageNumber = false){
            if(pageNumber){
                this.dataList = []
                this.param.pageNumber = 1;
            }
            if(this.param.typeName == "图层业务" || this.param.typeName == "业务模板" || this.param.typeName == "孪生体面板" || this.param.typeName == "场景控制插件" || this.param.typeName == "皮肤插件" || this.param.typeName == "核心插件" || this.param.typeName == "扩展插件" || this.param.typeName == "操作原子") {
                
                let paramZero = {
                    pageNumber: this.param.pageNumber,// 页码
                    pageSize: this.param.pageSize,// 条数
                    type: this.param.type-0, // 资源类型
                    resourceName: this.$store.state.thingXsearch, // 资源名称
                };
                postThingxPlugins(paramZero).then(res =>{
                    this.isLoadComplete = true
                    if(this.param.pageNumber != 1){
                        this.dataList.push(...res.content.list);
                    }else{
                        this.dataList = res.content.list;
                        bus.$emit('changeListCount',res.content.totalRow);
                    }
                    this.isLoadComplete = true
                    if(!res.content.list.length || res.content.list.length < this.param.pageSize) this.isLastPage = true
                }).catch(e =>{
                    console.log(e)
                })
            }else {
                postLowCodePlugins(this.param).then((res) => {
                    if(this.param.pageNumber != 1){
                        this.dataList.push(...res.content.list);
                    }else{
                        this.dataList = res.content.list;
                        bus.$emit('changeListCount',res.content.totalRow);
                    }
                    this.isLoadComplete = true
                    if(!res.content.list.length || res.content.list.length < this.param.pageSize) this.isLastPage = true
                }).catch(e =>{
                    console.log(e)
                })
            }
        },
        onscrollData(){
            let self = this;
            window.onscroll = function() {
                //变量scrollTop是滚动条滚动时，距离顶部的距离
                var scrollTop = document.documentElement.scrollTop||document.body.scrollTop;
                //变量windowHeight是可视区的高度
                var windowHeight = document.documentElement.clientHeight || document.body.clientHeight;
                //变量scrollHeight是滚动条的总高度
                var scrollHeight = document.documentElement.scrollHeight||document.body.scrollHeight;
                //滚动条到底部的条件
                if(scrollTop+windowHeight == scrollHeight && self.dataList.length >= 24){
                    //写后台加载数据的函数
                    self.param.pageNumber ++;
                    self.init()
                }
            }
        },
        clickImgBg(data, flag, index){
            if(flag){
                if(index>=0){
                    data._index = index +1;
                }
                var msg = {title:'预览资源',subject:'thingx-plugin',toolInfo:{data:data}};
                bus.$emit('view',msg);
                return
            }
            if(data.url) {
                window.open(data.url);
                return;
            }
            if(data.typeName == "图表"){
                if(data.img) {
                    this.propContent.clickImgBgUrl = data.img;
                }else {
                    this.propContent.clickImgBgUrl = `https://3dmomoda-static.oss-cn-beijing.aliyuncs.com/chart/${data._id}.jpg`;
                }
            }else{
                this.propContent.clickImgBgUrl = data.img;
            }
            this.propContent.title = data.name;
            this.popupshow = true;
            document.documentElement.style.cssText = 'overflow:none;';
            document.body.style.cssText = 'overflow:hidden;padding:0 17px 0 0;';
        },
        cancelClick(val){
            this.popupshow = val;
        },

        // 鼠标滑过预览插件
        showTooltip(event) {
            var content = $(event.target).data("content");
            var tipEle ='<div class="tooltips" style="left:-15px"><div class="arrow"></div>' + content +'</div>';
            $(event.target).append(tipEle);
        },
        // 鼠标划出预览插件
        cancelTooltip() {
            $("div").remove(".tooltips");
        },
        closeDecor(val){
            this.decorshow = val;
        }
    }
}
</script>

<style lang = "less" scoped>
    #page-content{
        margin-top: 40px;
        min-height: 888px;
        .content-list{
            width: 80%;
            max-width: 2000px;
            margin: 0 auto;
            display: block;
            ul{
                display: flex;
                flex-direction: row;
                flex-wrap: wrap;
                margin: -18px -15px;
                transition: opacity .15s ease-in-out;
                li{
                    margin: 0 16px 30px 15px;
                    border: 1px solid #e5e9ef;
                    border-radius: 4px;
                    position: relative;
                    background-color: #fff;
                    box-shadow: 0 1px 1px rgb(97 108 121 / 10%), 0 7px 18px 0 rgb(97 108 121 / 13%);
                    transition: box-shadow .2s ease;
                    .scene_img_box{
                        padding-top: 56.25%;
                        cursor: pointer;
                        border-top-left-radius: 3px;
                        border-top-right-radius: 3px;
                        position: relative;
                        background-repeat: no-repeat;
                        background-size: cover;
                        background-position: 50%;
                        overflow: hidden;
                        &:hover{
                            .tooltip-box{
                                opacity: 1;
                            }
                        }
                        .bottom_left{
                            position: absolute;
                            bottom: 10px;
                            left: 10px;
                            width: 36px;
                            height: 36px;
                            background-color: #222222;
                            border-radius: 100%;
                            box-shadow: 0 11px 20px 0 rgb(97 108 121 / 17%);
                            display: flex;
                            flex-direction: row;
                            justify-content: center;
                            align-items: center;
                            color: #fff;
                            opacity: 0;
                            z-index: 1;
                        }
                    }

                }
            }
        }
    }
    #page-content .recommand {
        position: absolute;
        /* top: -4px; */
        /* right: -25px; */
        /* padding: 10px; */
        border-top: 40px solid transparent;
        border-right: 40px solid transparent;
        border-left: 40px solid transparent;
        border-bottom: 40px solid #ff7f29;
        transform: rotate(315deg);
        content: "零代码";
        left: -40px;
        top: -40px;
    }
    #page-content .recommand:after {
        position: absolute;
        top: 17px;
        right: -23px;
        content: "零代码";
        width: 40px;
        color: #fff;
    }
    /* 媒体查询检查 */
    @media (min-width: 1910px){
        li {
            width: calc((100% - 120px)/4 - 1px);
        }
    }
    @media (max-width: 1910px){
        li {
            width: calc((100% - 90px)/3 - 1px);
        }
    }
    @media (max-width: 1600px){
        .li {
            width: calc((100% - 90px)/3 - 1px);
        }
    }
    @media (max-width: 1015px){
        li {
            width: calc((100% - 60px)/2 - 1px);
        }
    }
    @media (max-width: 700px){
        li {
            width: calc((100% - 30px)/1 - 1px);
            margin-top: -13px;
        }
    }
    @media (min-width: 1015px){
        li{
            animation: pat .8s 1;
        }
    }
    @keyframes pat{
        from {
            opacity: 0;
            transform: scale(1.2, 1.2);
        }
        to {
            opacity: 1;
            transform: scale(1, 1);
        }
    }
    @-moz-keyframes pat {
        from {
            opacity: 0;
            transform: scale(1.2, 1.2);
        }
        to {
            opacity: 1;
            transform: scale(1, 1);
        }
    }
    @-webkit-keyframes pat {
        from {
            opacity: 0;
            transform: scale(1.2, 1.2);
        }
        to {
            opacity: 1;
            transform: scale(1, 1);
        }
    }
    @-o-keyframes pat{
        from {
            opacity: 0;
            transform: scale(1.2, 1.2);
        }
        to {
            opacity: 1;
            transform: scale(1, 1);
        }
    }
    @media (max-width: 1480px) {
        .content-list {
            width:84% !important;
        }
    }
    @media (max-width: 1280px) {
        .content-list {
            width:88% !important;
        }
    }
    @media (max-width: 800px) {
        .content-list {
            width:calc(100% - 40px) !important;
        }
    }
</style>






// WEBPACK FOOTER //
// src/components/Plugins.vue